import { TRACKERS } from "@/constants/Trackers";
import { MedicalHistory } from "@/features/Patient/MedicalRecords/MedicalHistory/MedicalHistory";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/medical-history")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_MEDICAL_HISTORY);
  },
});

function RouteComponent() {
  return <MedicalHistory />;
}
